import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_DRIVERS](state, data) {
    state.allDrivers = data
  },
}
